<div class="heading-container" mat-dialog-title>
	<mode-dialog-header>
		<h1 heading>Push Changes</h1>
	</mode-dialog-header>
</div>
<form class="github-sync-form" [formGroup]="syncToGithubForm" (ngSubmit)="pushChanges()">
  <div class="modal-container" mat-dialog-content>
    <label for="commitMessage">
      <span class="primary-label">Commit Message</span>
      <span class="secondary-label">(appears with changes in GitHub)</span>
    </label>
    <textarea
      class="form-control no-resize"
      id="commitMessage"
      rows="5"
      formControlName="commitMessage"
    ></textarea>
  </div>
  <div class="modal-action-bar" mat-dialog-actions>
    <capra-button
      class="push-button"
      text="Push Changes"
			type="submit"
      [disabled]="!syncToGithubForm.valid"
    ></capra-button>
  </div>
</form>
